/**
 * Joins class names, dropping anything falsy.
 *
 * The type guard matters: CSS Module lookups are typed through an index
 * signature, so under `noUncheckedIndexedAccess` every `styles.foo` is
 * `string | undefined`. A plain `.filter(Boolean)` would not narrow that away.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ')
}
